(function(){
    document.body.addEventListener('click', function(e) {
        if(e.target && e.target.parentNode.classList.contains('form-input-quantity') && e.target.tagName === 'BUTTON') {
            var button = e.target;
            var input = button.parentNode.querySelector('input');
            var oldValue = input.value;
            var newVal = 0;
            var min = input.getAttribute('min');
            var max = input.getAttribute('max');

            if (button.classList.contains('btn-quantity-plus')) {
                newVal = parseInt(oldValue) + 1;
                if (newVal > max) newVal = max;
            } else {
                if (oldValue > min) {
                    newVal = parseInt(oldValue) - 1;
                } else {
                    newVal = min;
                }
            }

            input.value = newVal;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
    });

    document.body.addEventListener('keyup', checkInput);
    document.body.addEventListener('paste', checkInput);
    document.body.addEventListener('change', checkInput);

    function checkInput(e) {
        if(e.target && e.target.parentNode.classList.contains('form-input-quantity') && e.target.tagName === 'INPUT') {
            var input = e.target;
            var min = input.getAttribute('min');
            var max = input.getAttribute('max');
            var value = parseInt(input.value);
            var control = input.closest('.form-input-quantity');

            if (value < min) value = min;
            if (value > max) value = max;

            var buttons = control.querySelectorAll('.btn-quantity-minus, .btn-quantity-plus');
            buttons.forEach(function(button) {
                button.classList.remove('disabled');
                button.removeAttribute('disabled');
            });

            if (value == min) {
                control.querySelector('.btn-quantity-minus').classList.add('disabled');
                control.querySelector('.btn-quantity-minus').setAttribute('disabled', 'disabled');
            }

            if (value == max) {
                control.querySelector('.btn-quantity-plus').classList.add('disabled');
                control.querySelector('.btn-quantity-plus').setAttribute('disabled', 'disabled');
            }

            input.value = value;
        }
    }
})();